import './_index.scss';

import React, { Component } from 'react';

export default class Contact extends Component {
  render() {
    return (
      <div className="contact">
        <div className="wrapper">
          <h3 className="title">Contact Page</h3>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/ui-Contact/index.jsx
 **/